import { render, staticRenderFns } from "./PlanChangeFeedback.vue?vue&type=template&id=32a50812&scoped=true"
import script from "./PlanChangeFeedback.vue?vue&type=script&lang=ts"
export * from "./PlanChangeFeedback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a50812",
  null
  
)

export default component.exports